import { clsx } from 'clsx'
import { Slide } from 'component/Carousel/co/Slide'
import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import css from './Slides.module.scss'

type Props<T> = {
  store: CarouselStore<T>
  render: (item: T) => ReactElement
  center?: boolean
}

export const Slides = observer(<T, >(props: Props<T>) => {
  const { store, render, center } = props
  const className = clsx('slides', css.slides)

  const onRef = useLatestCallback((root: HTMLDivElement | null) => {
    store.root = root
  })

  return <Space ref={onRef} className={className} tall={center} center={center}>
    {store.items.map((item, index) => <Slide key={index}>
      {render(item)}
    </Slide>)}
  </Space>
})
